import React from 'react';
import './style.css';
import { FaChurch, FaCameraRetro, FaHeart, FaMusic } from 'react-icons/fa6';
import { GiKnifeFork } from 'react-icons/gi';

export class Agenda extends React.Component {
    render() {
        return (
            <div id="agenda-screen">
                <div className="agenda-container">
                    <div className="agenda-header-container">
                        <div className="agenda-header-content">DAS PROGRAMM</div>
                    </div>
                    <div className="agenda-content-container">
                        <div className="agenda-left-container">
                            {' '}
                            <div className="agenda-top-container">
                                <div className="agenda-top-spacer"></div>
                                <div className="agenda-top-content">EINTREFFEN IN DER KIRCHE</div>
                                <div className="agenda-top-spacer"></div>
                                <div className="agenda-top-content">TRAUUNG</div>
                                <div className="agenda-top-spacer"></div>
                                <div className="agenda-top-content">GRUPPENFOTO</div>
                                <div className="agenda-top-spacer"></div>
                                <div className="agenda-top-content">ABENDESSEN</div>
                                <div className="agenda-top-spacer"></div>
                                <div className="agenda-top-content">GEMEINSAMES FEST</div>
                                <div className="agenda-top-spacer"></div>
                            </div>
                        </div>

                        <div className="agenda-main-container">
                            <div className="agenda-timeline-container">
                                <div className="agenda-timeline-connector"></div>
                                <div className="agenda-timeline-item">
                                    <FaChurch size={'2vh'} />
                                </div>
                                <div className="agenda-timeline-connector"></div>
                                <div className="agenda-timeline-item">
                                    <FaHeart size={'2vh'} color="red" />
                                </div>
                                <div className="agenda-timeline-connector"></div>
                                <div className="agenda-timeline-item">
                                    <FaCameraRetro size={'2vh'} />
                                </div>
                                <div className="agenda-timeline-connector"></div>
                                <div className="agenda-timeline-item">
                                    <GiKnifeFork size={'2vh'} />
                                </div>
                                <div className="agenda-timeline-connector"></div>
                                <div className="agenda-timeline-item">
                                    <FaMusic size={'2vh'} />
                                </div>
                                <div className="agenda-timeline-connector"></div>
                                {/* <div className="agenda-timeline-item">
                                    
                                </div>
                                <div className="agenda-timeline-item">2</div>
                                <div className="agenda-timeline-item">3</div>
                                <div className="agenda-timeline-item">4</div>
                                <div className="agenda-timeline-item">5</div> */}
                            </div>
                        </div>
                        <div className="agenda-right-container">
                            <div className="agenda-top-time-container">
                                <div className="agenda-top-time-spacer"></div>
                                <div className="agenda-top-time-content">12:00</div>
                                <div className="agenda-top-time-spacer"></div>
                                <div className="agenda-top-time-content">12:30</div>
                                <div className="agenda-top-time-spacer"></div>
                                <div className="agenda-top-time-content">14:00</div>
                                <div className="agenda-top-time-spacer"></div>
                                <div className="agenda-top-time-content">18:00</div>
                                <div className="agenda-top-time-spacer"></div>
                                <div className="agenda-top-time-content">21:00</div>
                                <div className="agenda-top-time-spacer"></div>
                            </div>
                        </div>
                    </div>
                    {/* <div className="agenda-overlay-container">
                        <div className="agenda-overlay-content-container">
                            <div className="agenda-overlay-content">FINDET IHR ZU EINEM SPÄTEREN ZEITPUNKT HIER :)</div>
                        </div>
                    </div> */}
                </div>
            </div>
        );
        // <div className="title-header">Screen 3</div>;
    }
}
